"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendDistribution = void 0;
function extendDistribution(count, type, current) {
    const res = current !== null && current !== void 0 ? current : { total: 0, byType: {} };
    if (!res.byType) {
        res.byType = {};
    }
    if (count > 0) {
        res.byType[type] = (res.byType[type] || 0) + count;
        res.total += count;
    }
    return res;
}
exports.extendDistribution = extendDistribution;
//# sourceMappingURL=distribution.js.map